import React from "react";

import { useSelector } from "react-redux";
import { getRevenue } from "../../../Redux/features/Dashboard/Charts/RevenueChartSlice";
import { removeCurrencySign, formatCurrency } from "../../../Constants/utils";
import { CommonChart } from "./CommonChart";

export const RevenueChart = ({
  merchantId,
  activeType,
  presentDate,
  revenueChartInView,
  revenueChartRef,
  selectedOutletIds = [],
}) => {
  const revenueChart = useSelector((state) => state.revenueChart);
  const chartKey = "revenueChart";

  return (
    <>
      <CommonChart
        componentRef={revenueChartRef}
        activeType={activeType}
        formatFunction={removeCurrencySign}
        presentDate={presentDate}
        sliceCallback={getRevenue}
        yAxisText={"Metric (e.g., revenue in $)"}
        reduxState={revenueChart}
        reduxStateKey={"revenueData"}
        reduxStateTotalKey={"totalRevenue"}
        valueKey={"total_revenue"}
        chartKey={chartKey}
        merchantId={merchantId}
        chartInView={revenueChartInView}
        title={"Total Sales Revenue"}
        totalValueFunction={formatCurrency}
        selectedOutletIds={selectedOutletIds}
      />
    </>
  );
};
